module.exports = __webpack_public_path__ + "static/media/2.e3774c2b.png";